<template>
<div class="select-input-wrapper">
    <div v-show="is_open" class="select-input-background" @click="is_open = false"></div>

    <div :class="['select-input', { disabled, open: is_open }]">
        <div class="select-input-selected" @click="onToggleDropdown">
            <div>
                <span v-if="!active_choice">&nbsp;</span>
                <span class="flex ai-c" v-if="active_choice">
                    <span v-html="active_choice.label"></span>
                    &nbsp;
                    <span v-show="active_choice.badge !== null && active_choice.badge !== 0" class="badge">{{ active_choice.badge }}</span>
                </span>
            </div>
            <span class="arrow">
                <span v-show="!is_open"><i class="material-icons">keyboard_arrow_down</i></span>
                <span v-show="is_open"><i class="material-icons">keyboard_arrow_up</i></span>
            </span>
        </div>

        <div :class="['select-input-choices', { fixed: fixed ,open: is_open }]">
            <div :class="['choice', { disabled: choice.disabled, divider: choice.divider }]" v-for="(choice, index) in choices" :key="choice.key"
                @click="onOptionChange(index)">
                <span v-if="choice.divider" class="choice-inner"></span>
                <span v-else class="flex ai-c choice-inner">
                    <span v-show="choice.indent" class="indent">&mdash;</span>
                    <span v-html="choice.label"></span>
                    &nbsp;
                    <span v-show="choice.badge !== null && choice.badge !== 0" class="badge">{{ choice.badge }}</span>
                </span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "select-input",

    props: {
        activeIndex: {
            default: 0
        },

        choices: Array,

        disabled: Boolean,

        fixed: Boolean
    },

    data () {
        return {
            is_open: false
        }
    },

    computed: {
        active_choice: function () {
            const key = Object.keys(this.choices)[this.activeIndex]

            return this.choices[key]
        }
    },

    methods: {
        onOptionChange: function (selectedIndex) {
            if (this.choices[selectedIndex].disabled) {
                return
            }

            this.is_open = false

            this.$emit("change", selectedIndex)
        },

        onToggleDropdown: function () {
            if (!this.disabled) {
                this.is_open = !this.is_open
            }
        }
    }
}
</script>

<style>
.select-input-wrapper {
    cursor: pointer;
    position: relative;
    width: 100%;
}

.select-input-background {
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1;
}

.select-input {
    position: relative;
    z-index: 2;
}

.select-input.open {
    z-index: 3;
}

.select-input.disabled .select-input-selected {
    background: #f1f1f1;
}

.select-input-selected {
    border-radius: 1px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
    color: inherit;
    font: inherit;
    line-height: 1;
    padding: 10px;
    padding-right: 30px;
    position: relative;
    transition: all 0.15s ease;
}

.select-input-selected:hover {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.select-input-selected .arrow {
    right: 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.select-input-choices {
    background: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
    height: 0;
    left: 0;
    margin: 0 auto;
    max-height: 350px;
    opacity: 0.0;
    overflow: auto;
    position: absolute;
    right: 0;
    top: 100%;
    transition: all 0.15s ease;
    min-width: 100%;
    z-index: 1;
}

.select-input-choices.fixed {
    max-width: 600px;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - 20px);
}

.select-input-choices.open {
    height: auto;
    opacity: 1.0;
}

.select-input-choices .choice {
    background: transparent;
    padding: 10px;
    position: relative;
    transition: all 0.05s ease;
    white-space: nowrap;
}

.select-input-choices .choice.disabled {
    color: #c7c7c7;
    cursor: default;
}

.select-input-choices .indent {
    color: #c3c3c3;
    margin: 0 10px;
}

.select-input-choices .choice:not(.disabled):hover {
    background: #e1f4ff;
}

.select-input-choices .choice.divider:before {
    background: #f2f2f2;
    content: "";
    height: 2px;
    left: 0;
    position: absolute;
    top: 9px;
    width: 100%;
}
.select-input-choices .choice.divider:hover {
    background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectInput.vue